import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'zones';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

// FNP-1293 — SELECTION MOVES INTO REDUX, replacing the module-scoped
// `let globalSelection` + listener `Set` this module used to carry.
//
// The old store lived outside React, so it survived unmount and route changes:
// an operator who ticked a zone, navigated away and came back found the
// checkbox still ticked against a table that had refetched. It also outlived a
// test case, which is why it needed a `resetZonesSelection` export for the
// suite to call by hand. A slice needs neither — `setupStore` builds a fresh
// one per render, so isolation is structural rather than remembered.
//
// ⚠️ NO VISIBILITY SLICE HERE, unlike domain-names/registrars/top-level-domains.
// This module's keyword and filters already live in their own module-scoped
// stores (FNP-815) and are OUT OF SCOPE for this ticket. Adding a visibility
// slice nothing reads would be a second source of truth for paging.
export const ZonesReducer = combineReducers({
                                                selection: selectionSlice.reducer,
                                            });
